import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, Clock, ArrowLeft, Package } from 'lucide-react';

function OrderSuccessPage() {
  const { storeSlug } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const paymentMethod = searchParams.get('payment') || 'pix';
  const orderId = searchParams.get('order');
  
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate(`/menu/${storeSlug}`);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, storeSlug]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center">
        {/* Ícone de sucesso */}
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-12 h-12 text-green-600" />
        </div>
        
        {/* Título */}
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          Pedido Confirmado!
        </h1>
        
        {/* Subtítulo baseado no método de pagamento */}
        <p className="text-gray-600 mb-6">
          {paymentMethod === 'pix' ? (
            'Seu pagamento PIX foi confirmado com sucesso!'
          ) : (
            'Seu pedido foi realizado com sucesso!'
          )}
        </p>
        
        {/* Info do pedido */}
        {orderId && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-500">Número do pedido</p>
            <p className="text-lg font-semibold text-gray-800">#{orderId}</p>
          </div>
        )}
        
        {/* Status */}
        <div className="flex items-center justify-center gap-2 text-emerald-600 mb-6">
          <Package className="w-5 h-5" />
          <span className="font-medium">Em preparação</span>
        </div>
        
        {/* Mensagem de redirecionamento */}
        <div className="flex items-center justify-center gap-2 text-gray-500 text-sm mb-6">
          <Clock className="w-4 h-4" />
          <span>Redirecionando em {countdown} segundos...</span>
        </div>
        
        {/* Botão voltar */}
        <button
          onClick={() => navigate(`/menu/${storeSlug}`)}
          className="w-full flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-medium py-3 px-6 rounded-lg transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          Voltar ao Cardápio
        </button>
      </div>
    </div>
  );
}

export default OrderSuccessPage;
